import ClientAtradiusWarning from "../pages/clients/ClientAtradiusWarning";
import { isAtradiusRefused } from "../utils/atradiusRefusal";
const amount = (value) =>
  value !== null &&
  value !== undefined &&
  value !== "" &&
  Number.isFinite(Number(value))
    ? new Intl.NumberFormat("fr-FR", {
        style: "currency",
        currency: "EUR",
      }).format(Number(value))
    : "—";
const numeric = (value) =>
  value !== null &&
  value !== undefined &&
  value !== "" &&
  Number.isFinite(Number(value))
    ? Number(value)
    : null;
const date = (value) => {
  if (!value) return "—";
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime())
    ? "—"
    : parsed.toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric" });
};

export const coverStatus = (cover) => {
  const document = cover._doc || cover;
  const granted = numeric(document.totalDecision?.decisionAmtInPolicyCurrency);
  const invoice = numeric(cover.montantNonFacture);
  return isAtradiusRefused(cover)
    ? "Refusée"
    : granted === null || invoice === null
      ? "En attente"
      : invoice <= granted
        ? "OK"
        : "À revoir";
};

export default function AtradiusClientRow({ client, cover, onOpen }) {
  const document = cover._doc || cover;
  const granted = numeric(document.totalDecision?.decisionAmtInPolicyCurrency);
  const invoice = numeric(cover.montantNonFacture);
  const status = coverStatus(cover);
  return (
    <tr key={client._id} className="hover:bg-slate-50">
      <td className="px-4 py-5">
        <div className="flex items-center gap-3">
          <div>
            <button
              onClick={() => onOpen(client)}
              className="max-w-xs truncate text-left font-semibold text-slate-900 hover:text-blue-700"
              title={client.companyName}
            >
              {client.companyName || client.denomination || "—"}
            </button>
            <span className="ml-2 inline-block">
              <ClientAtradiusWarning
                cover={cover}
                onClick={() => onOpen(client)}
              />
            </span>
            <p className="mt-1 text-xs text-slate-500">{client.siret || "—"}</p>
          </div>
        </div>
      </td>
      <td className="whitespace-nowrap px-4 py-5 text-slate-600">
        {date(document.requestDate || document.createdAt)}
      </td>
      <td className="px-4 py-5">
        <span className="whitespace-nowrap rounded-full bg-blue-50 px-3 py-1 text-xs font-semibold text-blue-700">
          {document.coverType || "—"}
        </span>
      </td>
      <td className="whitespace-nowrap px-4 py-5 text-slate-600">
        {amount(document.creditLimitApplicationAmountInPolicyCurrency)}
      </td>
      <td className="whitespace-nowrap px-4 py-5 font-semibold text-slate-900">
        {amount(granted)}
      </td>
      <td className="whitespace-nowrap px-4 py-5 text-slate-600">
        {amount(invoice)}
      </td>
      <td className="px-4 py-5">
        <span
          className={`whitespace-nowrap rounded-full px-3 py-1 text-xs font-medium ${status === "OK" ? "bg-emerald-50 text-emerald-700" : status === "Refusée" ? "bg-rose-50 text-rose-700" : "bg-amber-50 text-amber-700"}`}
        >
          {status}
        </span>
      </td>
      <td className="px-4 py-5">
        <button
          onClick={() => onOpen(client)}
          aria-label={`Ouvrir la fiche client de ${client.companyName}`}
          className="rounded-lg p-2 text-slate-500 hover:bg-blue-50 hover:text-blue-700"
        >
          Fiche client
        </button>
      </td>
    </tr>
  );
}
